import { CHAT_LABEL_EMPTY_CHANNEL_LIST, CHAT_LABEL_EMPTY_MESSAGE_LIST } from '@features/components/Chat/constants';
import { PiChatText } from 'react-icons/pi';
import { EmptyStateProps } from '../types/chatMessages';

export const CustomEmptyMessagesState = ({ listType }: EmptyStateProps) => {
  return (
    <div className="flex items-center justify-center flex-col gap-4 text-base-30 h-full">
      <PiChatText size={40} />
      <p className="text-m-r">
        {listType === 'channel' ? CHAT_LABEL_EMPTY_CHANNEL_LIST : CHAT_LABEL_EMPTY_MESSAGE_LIST}
      </p>
    </div>
  );
};
